import gql from 'graphql-tag';

export const SEARCH_RECLAMACION = gql(`
   query SearchReclamacion($term: String!, $aggReclamacion: [AggReclamacionEnum], $size: Int!, $reclamacionFilter: ReclamacionFilterInput, $idioma: String){
         searchReclamacion(queryRequest: {	
                              query: $term, 
                              size: $size, 
                              reclamacionFilter: $reclamacionFilter,
                              aggReclamacion: $aggReclamacion 
                           }) {
            totalHits
            agregaciones
            reclamaciones {
               id
               token
               codigoProducto
               estado
               clienteIdLegal
               clienteNombre
               clienteApellidos
               acreedorIdLegal
               acreedorNombre
               acreedorApellidos
               acreedorRazonSocial
               deudorIdLegal
               deudorNombre
               deudorApellidos
               deudorRazonSocial
               score
               literalEstado(idioma: $idioma) {
                  valor
               } 
               literalProducto(idioma: $idioma) {
                  valor
               } 
            }
         }
}`)

export const GET_SUGGESTIONS_RECLAMACION = gql(`
   query SearchReclamacion($term: String!, $size: Int!){
      searchReclamacion(queryRequest: { query: $term, size: $size, }) {
         suggestion
      }
   }`)


export const GET_SUGGESTIONS_COMPANIES_MIX = gql(`
   query predictivo($request: BuscadorPredictivoMixRequestInput) {
      predictivo(buscadorPredictivoMixRequest: $request){
         sugerencia
         idLegal
         origenResultado
      }
   }
`)

export const GET_LIST_COMPANIES_MIX = gql(`
   query listadoEmpresas($request: BuscadorListaEmpresasMixRequestInput ) {
      listadoEmpresas(buscadorListaEmpresasMixRequest: $request){
         nombre
         provincia
         idLegal
         origenResultado
      }
   }
`)

export const GET_COMPANY_CARD_MIX = gql(`
query fichaEmpresa($request: BuscadorFichaEmpresaMixRequestInput) {
   fichaEmpresa(buscadorFichaEmpresaMixRequest: $request){
      apellidos
      sectorActividad
      codigoActividad
      razonSocial
      tipoSociedad
      codigoPostal
      direccion
      email
      idLegal
      municipio
      nombre
      provincia
      pais
      telefono
      tipoDireccion
      web
   }
}
`)

